import MailOutlinedIcon from '@mui/icons-material/MailOutlined';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

export const PROSPERO_SUPPORT_EMAIL = 'info@prospero.food';

export function ContactSupportButton() {
  const { t } = useTranslation();

  return (
    <Button
      variant="contained"
      component="a"
      href={`mailto:${PROSPERO_SUPPORT_EMAIL}`}
      startIcon={<MailOutlinedIcon />}
      sx={{ minHeight: 48 }}
    >
      {t('common.contactSupport')}
    </Button>
  );
}
